import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SummarizedResults from './SummarizedResults';
import SupportLitResults from './SupportLitResults';
import styles from './results.module.css';
import LoadingSpinner from '../../loadingSpinner/LoadingSpinner';
import ResultSectionHeaderMkII from './ResultSectionHeaderMkII';

const PER_PAGE = 25;

const propTypes = {
  studyGroups: PropTypes.objectOf(
    PropTypes.shape({
      results: PropTypes.arrayOf(PropTypes.object),
      fullCount: PropTypes.number,
      page: PropTypes.number,
    })
  ).isRequired,
  filteredKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  supportLit: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    fullCount: PropTypes.number,
    page: PropTypes.number,
  }).isRequired,
  updateCallback: PropTypes.func.isRequired,
  masterSearchQuery: PropTypes.object.isRequired,
  searchOccuredFlag: PropTypes.bool.isRequired,
  studiesLoading: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    newSearch: PropTypes.bool,
  }).isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageChangeLoading: PropTypes.object.isRequired,
  searchErrors: PropTypes.object.isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default function ResultsSection({
  studyGroups,
  filteredKeys,
  supportLit,
  updateCallback,
  masterSearchQuery,
  searchOccuredFlag,
  studiesLoading,
  onPageChange,
  pageChangeLoading,
  searchErrors,
  onDownload,
}) {
  const [forcedLoading, setForcedLoading] = useState(false);

  useEffect(() => {
    setForcedLoading(true);
    const timeOut = setTimeout(() => setForcedLoading(false), 300);
    return () => clearTimeout(timeOut);
  }, [masterSearchQuery]);

  if ((forcedLoading && studiesLoading.newSearch) || studiesLoading.loading)
    return <LoadingSpinner />;

  const fullCount = Object.values(studyGroups).reduce((sum, g) => sum + g.fullCount, 0);
  const systematicCount = studyGroups[1].fullCount;
  const clinicalCount = studyGroups[2].fullCount;
  const observationalCount = studyGroups[3].fullCount;
  const caseCount = studyGroups[4].fullCount;
  const unknownCount = studyGroups[5].fullCount;
  const limitedCount = Object.values(studyGroups).reduce((sum, g) => sum + g.results.length, 0);

  return (
    <>
      <div className={styles.resultsSection} aria-label="results section">
        <ResultSectionHeaderMkII
          searchFlag={searchOccuredFlag}
          studyCounts={{
            fullCount,
            systematicCount,
            clinicalCount,
            observationalCount,
            caseCount,
            unknownCount,
            limitedCount,
          }}
          supportLitCount={supportLit.fullCount}
          onDownload={onDownload}
        />
        {searchOccuredFlag && (
          <section className={styles.sectionContainer} aria-label="search results">
            <SummarizedResults
              studyGroups={studyGroups}
              searchFlag={searchOccuredFlag}
              filteredKeys={filteredKeys}
              updateCallback={updateCallback}
              onPageChange={onPageChange}
              pageChangeLoading={pageChangeLoading}
              searchErrors={searchErrors}
              perPage={PER_PAGE}
            />
            <SupportLitResults
              supportLit={supportLit}
              searchFlag={searchOccuredFlag}
              onPageChange={onPageChange}
              pageChangeLoading={pageChangeLoading}
              searchErrors={searchErrors}
              perPage={PER_PAGE}
            />
          </section>
        )}
        <br />
      </div>
    </>
  );
}

ResultsSection.propTypes = propTypes;
